module.exports = __webpack_public_path__ + "img/titlear.abed9702.png";